// extracted by mini-css-extract-plugin
module.exports = {"container":"i_CC","as-16x9":"i_CD","as-4x3":"i_CE","as-3x2":"i_CF","as-8x5":"i_CG","as-1x1":"i_CH","content":"i_CI"};